import { Box, Grid, LinearProgress, linearProgressClasses, styled } from "@mui/material";
import { Breadcrumbs, Button } from "@pmag/ui-components";

export const Root = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(6),
    [theme.breakpoints.up("sm")]: {
        paddingTop: theme.spacing(8),
    },
}));

interface TopContainerProps {
    showBorderBottom?: boolean;
}

export const TopContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "showBorderBottom",
})<TopContainerProps>(({ theme, showBorderBottom }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(6),
    ...(showBorderBottom && { borderBottom: `1px solid ${theme.palette.core.grey._20}` }),

    [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(8),
        borderBottom: "unset",
    },
}));

export const NavigationButton = styled(Button)(({ theme }) => ({
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
}));

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    flex: 1,
    height: "2px",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.core.grey._30,
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: theme.palette.core.grey._80,
    },
}));

export const ProgressContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(5),

    [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(7),
    },
}));

export const BreadcrumbsContainer = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        "& .MuiCollapse-root": {
            flex: 1,
        },
    },

    [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(5),
        justifyContent: "space-between",
    },

    [theme.breakpoints.up("lg")]: {
        marginBottom: theme.spacing(7),
    },

    display: "flex",
    alignItems: "center",
}));

export const BreadcrumbsWrapper = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderRight: `1px solid ${theme.palette.core.grey._40}`,
        borderBottom: `1px solid ${theme.palette.core.grey._40}`,
        borderLeft: `1px solid ${theme.palette.core.grey._40}`,
        marginBottom: theme.spacing(4),
    },
}));

export const StyledBreadcrumbs = styled(Breadcrumbs)({
    flexWrap: "wrap",
});

export const SwitchContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(5),

    [theme.breakpoints.up("md")]: {
        marginBottom: theme.spacing(7),
    },
}));

export const StyledGridItem = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down("sm")]: {
        borderBottom: `1px solid ${theme.palette.core.grey._20}`,
        "&:first-of-type": {
            borderTop: `1px solid ${theme.palette.core.grey._20}`,
        },
    },
}));
